<template>
  <div>
    <el-row>
      <el-button size="mini" type="primary" @click="downDetails()">一键导出</el-button>
    </el-row>
    <div class="boxPanel">
      <el-row>
        <div class="tableTit">{{ dateTime }} 早晚会详情表</div>
        <el-table :data="morningData" :header-cell-style="{background:'#eea456', color:'#ffffff',}" :span-method="spanMethod" border style="margin-top: 10px" size="mini">
          <el-table-column label="时间" prop="time" align="center" width="85px"/>
          <el-table-column label="员工姓名" prop="name" align="center" width="80px"/>
          <el-table-column label="工号" prop="workcode" align="center" width="85px"/>
          <el-table-column label="部门" prop="secretary_department_name" align="center"/>
          <el-table-column :show-overflow-tooltip="true" label="会议主题" prop="subject" align="center">
            <template slot-scope="scope">
              <label class="forDetail" @click="morningDetails(scope.row.meeting_id)" v-html="scope.row.subject"/>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="会议纪要" prop="summary" align="center">
            <template slot-scope="scope">
              <label v-html="scope.row.summary"/>
            </template>
          </el-table-column>
          <el-table-column label="早会开始时间" prop="morning_start" align="center" width="95px"/>
          <el-table-column label="早会结束时间" prop="morning_end" align="center" width="95px"/>
          <el-table-column label="早会时长(分)" prop="morning_time" align="center" width="95px"/>
          <el-table-column label="晚会开始时间" prop="night_start" align="center" width="95px"/>
          <el-table-column label="晚会结束时间" prop="night_end" align="center" width="95px"/>
          <el-table-column label="晚会时长(分)" prop="night_time" align="center" width="95px"/>
          <el-table-column label="早会参会状态" prop="u_status" align="center" width="95px">
            <template slot-scope="scope">
                <span v-show="scope.row.u_status==item.value"  v-for="(item,index) in u_statusList" :key="index" :class="item.color">{{item.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="晚会参会状态" prop="n_status" align="center" width="95px">
            <template slot-scope="scope">
               <span v-show="scope.row.u_status==item.value"  v-for="(item,index) in u_statusList" :key="index" :class="item.color">{{item.name}}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="任务详情" prop="task" align="center">
            <template slot-scope="scope">
              <label v-html="scope.row.task"/>
            </template>
          </el-table-column>
          <el-table-column label="执行状态" prop="task_status" align="center" width="80px">
            <template slot-scope="scope">
              <span v-if="scope.row.task_status==0" class="grayColor">草稿</span>
              <span v-if="scope.row.task_status==1" class="greenColor">已执行待确认</span>
              <span v-if="scope.row.task_status==2" class="successColor">确认完成</span>
              <span v-if="scope.row.task_status==3" class="yellowColor">未执行</span>
              <span v-if="scope.row.task_status==4">会议取消，任务取消</span>
              <span v-if="scope.row.task_status==5">会议未进行，任务取消</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="执行情况" prop="task_opt" align="center">
            <template slot-scope="scope">
              <label v-html="scope.row.task_opt"/>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row style="margin-top: 20px">
        <div class="tableTit">{{ dateTime }} 大杂会详情表</div>
        <el-table
          :data="otherData"
          :header-cell-style="{background:'#7dbcf5', color:'#ffffff',}"
          :span-method="spanMethod1"
          border
          style="margin-top: 10px"
          size="mini">
          <el-table-column label="时间" prop="time" align="center" width="85px"/>
          <el-table-column label="员工姓名" prop="name" align="center" width="80px"/>
          <el-table-column label="工号" prop="workcode" align="center" width="85px"/>
          <el-table-column label="部门" prop="secretary_department_name" align="center"/>
          <!-- <el-table-column label="级别" prop="level" align="center" width="80px"></el-table-column> -->
          <el-table-column label="会议类型" prop="meeting_type_name" align="center" width="100px"/>
          <el-table-column :show-overflow-tooltip="true" label="会议主题" prop="subject" align="center">
            <template slot-scope="scope">
              <label class="forDetail" @click="otherDetails(scope.row.meeting_id)" v-html="scope.row.subject"/>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="会议纪要" prop="summary" align="center">
            <template slot-scope="scope">
              <label v-html="scope.row.summary"/>
            </template>
          </el-table-column>
          <el-table-column label="实际开始时间" prop="start_time" align="center" width="95px"/>
          <el-table-column label="实际结束时间" prop="end_time" align="center" width="95px"/>
          <el-table-column label="会议时长(分)" prop="minute" align="center" width="95px"/>
          <el-table-column label="参会状态" prop="u_status" align="center" width="80px">
            <template slot-scope="scope">
               <span v-show="scope.row.u_status==item.value"  v-for="(item,index) in u_statusList" :key="index" :class="item.color">{{item.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="任务标题" prop="task_name"/>
          <el-table-column :show-overflow-tooltip="true" label="任务详情" prop="task_desc" align="center">
            <template slot-scope="scope">
              <label v-html="scope.row.task_desc"/>
            </template>
          </el-table-column>
          <el-table-column label="执行状态" prop="task_status" align="center" width="80px">
            <template slot-scope="scope">
              <span v-if="scope.row.is_complete==1 && scope.row.is_overdue==1" class="grayColor">逾期完成</span>
              <span v-if="scope.row.is_complete==0 && scope.row.is_overdue==1" class="greenColor">逾期未完成</span>
              <span v-if="scope.row.is_complete==1 && scope.row.is_overdue==0" class="successColor">完成</span>
              <span v-if="scope.row.is_complete==0 && scope.row.is_overdue==0" class="yellowColor">未完成</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="执行情况" prop="task_opt" align="center" width="90px">
            <template slot-scope="scope">
              <label v-html="scope.row.task_opt"/>
            </template>
          </el-table-column>
          <el-table-column label="计划完成时间" prop="planned_complete_time" align="center" width="100px"/>
          <el-table-column label="实际完成时间" prop="complete_time" align="center" width="100px"/>
        </el-table>
      </el-row>
    </div>
  </div>
</template>
<script>
import { getDetails } from '@/api/static'
import { Loading } from 'element-ui'
import axios from 'axios'
export default {
  data() {
    return {
      morningData: [],
      otherData: [],
      dateTime: '',
      workcode: '',
      u_statusList: [
        {
          name: '待开会',
          value: 0,
          color: 'grayColor'
        },
        {
          name: '参加',
          value: 1,
          color: 'successColor'
        },
        {
          name: '请假',
          value: 2,
          color: 'yellowColor'
        },
        {
          name: '早退',
          value: 3,
          color: 'greenColor'
        },
        {
          name: '拒绝',
          value: 4,
          color: 'rejectColor'
        },
        {
          name: '缺席',
          value: 5,
          color: 'rejectColor'
        },
        {
          name: '会议取消',
          value: 6

        },
        {
          name: '会议未进行',
          value: 7

        }
      ]
    }
  },
  created() {
    console.log(sessionStorage.getItem('date'))
    console.log(sessionStorage.getItem('person'))
    const time = sessionStorage.getItem('date')
    if (sessionStorage.getItem('date') && sessionStorage.getItem('person')) {
      this.dateTime = time.split(',')[0] + ' ~ ' + time.split(',')[1]
      this.workcode = sessionStorage.getItem('person')
      this.getDetailMsg()
    } else {
      this.$message.error('请从统计列表页点击人员进入到详情页')
    }
  },
  methods: {
    // 合并行
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 13) {
        if (row.num) {
          return {
            rowspan: row.num,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    spanMethod1({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 10) {
        if (row.num) {
          return {
            rowspan: row.num,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    getDetailMsg() {
      const params = {
        start_time: this.dateTime.split(' ~ ')[0],
        end_time: this.dateTime.split(' ~ ')[1],
        workcode: this.workcode
      }
      const load = Loading.service({
        target: 'boxPanel',
        spinner: 'el-icon-loading',
        fullscreen: false,
        background: 'rgba(0,0,0,0.3)',
        text: '数据加载中...'
      })
      this.morningData = []
      this.otherData = []
      getDetails(params).then(res => {
        load.close()
        console.log(res)
        if (res.code === 'success') {
          // 先按照时间排序数据
          res.data.morningNight.sort((a, b) => {
            return parseInt(a.start_time.split(' ')[0].replace(/-/g, '')) - parseInt(b.start_time.split(' ')[0].replace(/-/g, ''))
          })
          res.data.other.sort((a, b) => {
            return parseInt(a.start_time.split(' ')[0].replace(/-/g, '')) - parseInt(b.start_time.split(' ')[0].replace(/-/g, ''))
          })
          // 早晚会
          console.log(res.data.morningNight)
          res.data.morningNight.forEach(item => {
            const common = {
              meeting_id: item.meeting_id,
              time: item.meeting_time,
              name: item.name,
              workcode: item.workcode,
              subject: item.meeting_subject ? item.meeting_subject.replace(/\n/g, '<br/>') : '',
              summary: item.summary ? item.summary.replace(/\n/g, '<br/>') : '',
              morning_start: item.start_time.split(' ')[1],
              morning_end: item.end_time.split(' ')[1],
              morning_time: item.morning_minute,
              night_start: item.night_start_time.split(' ')[1],
              night_end: item.night_end_time.split(' ')[1],
              night_time: item.night_minute,
              u_status: item.u_status,
              n_status: item.n_status,
              secretary_department_name: item.secretary_department_name
            }
            if (item.tasks.length > 0) {
              item.tasks.forEach((element, index) => {
                const json = JSON.parse(JSON.stringify(common))
                json.task = element.task_name ? element.task_name.replace(/\n/g, '<br/>') : ''
                json.task_status = element.task_status
                let progress = ''
                if (element.progress.length > 0) {
                  element.progress.forEach(pre => {
                    progress = progress + '' + pre.replace(/\n/g, '<br/>')
                  })
                } else {
                  progress = element.progress[0]
                }
                json.task_opt = progress
                if (index === 0) {
                  json.num = item.tasks.length
                }
                this.morningData.push(json)
              })
            } else {
              const json = JSON.parse(JSON.stringify(common))
              json.task = ''
              json.task_status = null
              json.task_opt = ''
              json.num = 1
              this.morningData.push(json)
            }
          })
          console.log(this.morningData)
          // 大杂会
          res.data.other.forEach(item => {
            const common = {
              meeting_id: item.meeting_id,
              time: item.start_time.split(' ')[0],
              name: item.name,
              workcode: item.workcode,
              meeting_type_name: item.meeting_type_name,
              subject: item.meeting_subject ? item.meeting_subject.replace(/\n/g, '<br/>') : '',
              summary: item.summary ? item.summary.replace(/\n/g, '<br/>') : '',
              start_time: item.start_time.split(' ')[1],
              end_time: item.end_time.split(' ')[1],
              minute: item.minute,
              u_status: item.u_status,
              secretary_department_name: item.secretary_department_name
            }

            if (item.tasks.length > 0) {
              item.tasks.forEach((element, index) => {
                const json = JSON.parse(JSON.stringify(common))
                json.task_name = element.task_name ? element.task_name.replace(/\n/g, '<br/>') : ''
                json.task_desc = element.task_desc ? element.task_desc.replace(/\n/g, '<br/>') : ''
                json.task_status = element.task_status
                json.planned_complete_time = element.planned_complete_time
                json.complete_time = element.complete_time
                json.is_complete = element.is_complete
                json.is_overdue = element.is_overdue
                let progress = ''
                if (element.progress.length > 0) {
                  element.progress.forEach(pre => {
                    progress = progress + '' + pre.replace(/\n/g, '<br/>')
                  })
                } else {
                  progress = element.progress[0]
                }
                json.task_opt = progress
                if (index === 0) {
                  json.num = item.tasks.length
                }
                this.otherData.push(json)
              })
            } else {
              const json = JSON.parse(JSON.stringify(common))
              json.task = ''
              json.task_status = null
              json.task_opt = ''
              json.num = 1
              this.otherData.push(json)
            }
          })
          console.log(this.otherData)
        } else {
          this.morningData = []
          this.otherData = []
        }
      }).catch(() => {
        load.close()
      })
    },
    // 链接会议详情
    morningDetails(id) {
      this.$router.push({ name: 'morningDetails', query: { id: id }})
    },
    otherDetails(id) {
      this.$router.push({ name: 'seeDetails', query: { id: id }})
    },
    // 下载详表
    downDetails() {
      const params = {
        start_time: this.dateTime.split(' ~ ')[0],
        end_time: this.dateTime.split(' ~ ')[1],
        workcode: [this.workcode]
      }
      let message = ''
      let fileName = ''
      if (params.start_time === params.end_time) {
        message = `下载 ${params.start_time} 日的详情表数据？`
        fileName = `${params.start_time}日详情表.xls`
      } else {
        message = `下载 ${params.start_time}日 到 ${params.end_time}日的详情表数据？`
        fileName = `${params.start_time}至${params.end_time}详情表.xls`
      }
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios({
          // url: 'http://190.168.1.50:9095/api/statistics/exportAttendeesDetail',  // 测试
          url: `${process.env.VUE_APP_BASE_API}/statistics/exportAttendeesDetail`, // 正式
          method: 'post',
          data: params,
          headers: { Authorization: this.$store.getters.token },
          responseType: 'blob'
        }).then(res => {
          console.log(res)
          const blobUrl = window.URL.createObjectURL(res.data)
          download(blobUrl)
          function download(blobUrl) {
            const aa = document.createElement('a')
            aa.style.display = 'none'
            aa.download = fileName
            aa.href = blobUrl
            aa.click()
            // document.body.removeChild(aa);
          }
        })
      }).catch(() => {

      })
    }
  }
}
</script>
<style lang="scss">
  .tableTit{
    line-height: 24px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    color: #909399;
  }
  @mixin colors($color){
    color: $color
  }
  .grayColor{
    color: #bdbaba
  }
  .successColor{
    // color: #67c23a
    @include colors(#67c23a)
  }
  .yellowColor{
    color: #ffd966
  }
  .greenColor{
    color: #a4c2f4
  }
  .rejectColor{
    color: #cc4125
  }
  @mixin color-link($color, $hover){
    color: $color;
    cursor: pointer;
    &:hover{
      color: $hover;
      text-decoration: underline
    }
  }
  .forDetail{
    @include color-link(#6d9eeb, #4183ea)
  }
</style>
